import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { PageHeader } from '@/components/layout/PageHeader';
import { ConversationsTab } from '@/components/chat/ConversationsTab';
import { ArticleQaTab } from '@/components/chat/ArticleQaTab';
import { StatsTab } from '@/components/chat/StatsTab';
import { normalizeChatSearch, normalizeChatTab } from '@/lib/route-search';

export const Route = createFileRoute('/chat')({
  validateSearch: normalizeChatSearch,
  component: ChatPage,
});

function ChatPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/chat' });

  return (
    <>
      <PageHeader title="AI 챗" description="대화 내역 · 글 Q&A · 통계" />
      <Tabs
        value={search.tab}
        onValueChange={value => {
          void navigate({ search: { tab: normalizeChatTab(value) } });
        }}
      >
        <TabsList><TabsTrigger value="conversations">대화</TabsTrigger><TabsTrigger value="article-qa">글 Q&A</TabsTrigger><TabsTrigger value="stats">통계</TabsTrigger></TabsList>
        <TabsContent value="conversations" className="mt-6"><ConversationsTab /></TabsContent>
        <TabsContent value="article-qa" className="mt-6"><ArticleQaTab /></TabsContent>
        <TabsContent value="stats" className="mt-6"><StatsTab /></TabsContent>
      </Tabs>
    </>
  );
}
